import { defineTable } from "convex/server";
import { v } from "convex/values";
import { modulesTypes } from "../permissions";

// ============= TABLA: NOTIFICATIONS =============

export const notificationType = v.union(
  // Commercial - Sales
  v.literal("sale_created"),
  v.literal("sale_updated"),
  v.literal("sale_cancelled"),
  v.literal("sale_sent"),
  // Commercial - Quotations
  v.literal("quotation_created"),
  v.literal("quotation_approved"),
  v.literal("quotation_expired"),
  // Commercial - General
  v.literal("message_received"),
  // Billing - Invoices
  v.literal("invoice_created"),
  v.literal("invoice_completed"),
  v.literal("invoice_cancelled"),

  // Billing - Payments
  v.literal("payment_received"),
  v.literal("payment_overdue"),
  // Billing - Correlatives
  v.literal("correlative_range_warning"),
  v.literal("correlative_range_exhausted"),
  v.literal("correlative_expiration_warning"),
  v.literal("correlative_expired"),
  // Billing - Credit
  v.literal("credit_limit_warning"),
  v.literal("credit_overdue"),
  // Reports
  v.literal("report_ready"),
  v.literal("report_failed"),
  v.literal("report_shared"),
  // Subscriptions
  v.literal("subscription_expired"),
  v.literal("trial_ending"),
  v.literal("trial_ended"),
  v.literal("grace_period_ending"),
  v.literal("trial_ending_soon"),
  v.literal("grace_period_reminder"),
  v.literal("limit_exceeded"),
  v.literal("limit_warning"),
  // Operations - Work Orders
  v.literal("work_order_created"),
  v.literal("work_order_status_changed"),
  v.literal("work_order_completed"),
  v.literal("work_order_assigned"),
  // AI Insights
  v.literal("ai_insight_critical"),
  v.literal("ai_insight_warning"),
  v.literal("ai_daily_summary"),
  v.literal("ai_weekly_summary"),
  // Colecciones - Automatizaciones configuradas por la organización
  v.literal("collection_automation"),
  // Scripts (Cohorte F, 2026-10-11): notificaciones disparadas por
  // el codigo del admin via `notify.sendInApp`. Sin modulo ni modulo
  // origen, llegan como `script_event` y la UI los agrupa por tipo.
  v.literal("script_event"),
);

export const validatorNotification = v.object({
  userId: v.id("users"),
  companyId: v.id("companies"), // Para multi-tenant

  // Tipo y contenido
  type: notificationType,
  title: v.string(),
  message: v.string(),
  url: v.optional(v.string()),

  // Referencia al reporte
  reportId: v.optional(v.id("reports")),
  executionId: v.optional(v.id("report_executions")),
  module: v.optional(modulesTypes),

  // Estado
  read: v.boolean(),
  readAt: v.optional(v.number()),

  // Metadata
  createdAt: v.number(),
});

export const notifications = defineTable(validatorNotification)
  .index("by_user_id", ["userId"])
  .index("by_company_id", ["companyId"])
  .index("by_read", ["read"])
  .index("by_user_and_read", ["userId", "read"])
  .index("by_created_at", ["createdAt"]);
